module.exports = __webpack_public_path__ + "909d633b6fd5b53d3eddd9f62abc8a27.svg";